export default "__VITE_ASSET__3cd8b13e__"